import { getToken } from '@/utils/auth'

const getters = {
  objApi: state => state.api,
  token: state => state.user.token,
  userInfo: state => state.user.userInfo,
  menuInfo: state => state.user.menuInfo,
  sidebar: state => state.app.sidebar,
  needMobile: state => state.app.needMobile,
  platFormApp: state => state.platFormApp,
  powerBtn: state => state.powerBtn.btnList,
  tree: state => state.tree.data,
  treeOper: state => state.tree.operate
};
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js